import { useMemo } from "react";
import { useDevAgentStore } from "@/stores/devAgentStore";

/** Session summary — shows Q&A pairs from this session. Click to scroll to that message. */
export function ConversationSummaryInner() {
  const feedItems = useDevAgentStore((s) => s.feedItems);

  const qaPairs = useMemo(() => {
    const pairs: {
      id: string;
      question: string;
      answer: string;
      timestamp: number;
    }[] = [];
    for (let i = 0; i < feedItems.length; i++) {
      const item = feedItems[i];
      if (item.type !== "chat_user") continue;
      const question = item.data.content || "";
      if (question.length < 3) continue;
      let answer = "";
      for (let j = i + 1; j < feedItems.length; j++) {
        if (
          feedItems[j].type === "chat_agent" &&
          feedItems[j].data.content
        ) {
          const full = feedItems[j].data.content.replace(/[#*`]/g, "").trim();
          const firstSentence = full.split(/[.\n]/)[0]?.trim() || "";
          answer =
            firstSentence.length > 80
              ? firstSentence.slice(0, 77) + "..."
              : firstSentence;
          break;
        }
        if (feedItems[j].type === "chat_user") break;
      }
      pairs.push({
        id: item.id,
        question:
          question.length > 60 ? question.slice(0, 57) + "..." : question,
        answer,
        timestamp: item.timestamp || 0,
      });
    }
    return pairs;
  }, [feedItems]);

  const scrollToMessage = (id: string) => {
    const el = document.querySelector(`[data-feed-item-id="${id}"]`);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return qaPairs.length > 0 ? (
    <div className="space-y-1.5">
      {qaPairs.map((qa) => (
        <button
          type="button"
          key={qa.id}
          onClick={() => scrollToMessage(qa.id)}
          className="w-full text-left py-1.5 px-2 rounded hover:bg-muted/50 transition-colors cursor-pointer group"
        >
          <div className="text-xs font-semibold text-foreground truncate">{qa.question}</div>
          {qa.answer && (
            <div className="text-[10px] text-muted-foreground truncate mt-0.5">
              {qa.answer}
            </div>
          )}
          {qa.timestamp > 0 && (
            <div className="text-[9px] text-muted-foreground/80 mt-0.5">
              {new Date(qa.timestamp).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          )}
        </button>
      ))}
    </div>
  ) : (
    <div className="text-muted-foreground text-center py-2 text-xs">
      Questions & answers appear here as you chat
    </div>
  );
}
